<template lang="html">
  <div v-if="pageContent">
    <v-row>
      <v-col cols="2" class="side-bar">
        <div class="page-title">
          {{
            id == "MRA" ? "" : type == "deelregio" ? "Deelregio" : "Deelsector"
          }}
          {{ id }}
        </div>
        <div class="nav">
          <div class="nav-link">
            <router-link to="/">Overzichtspagina</router-link>
          </div>
          <div class="nav-link">
            <router-link to="/dashboard">Dashboard</router-link>
          </div>
        </div>
      </v-col>
      <v-col cols="10">
        <template v-if="'image' in pageContent">
          <img :src="imgUrl" />
        </template>
        <template v-else>
          <div class="spacing"></div>
        </template>
        <v-row
          v-for="(section, i) in pageContent.sections"
          :key="`section_${i}`"
        >
          <template v-if="section.type == 'text'">
            <v-col cols="12">
              <div class="content-title" v-if="'title' in section">
                {{ section.title }}
              </div>
              <div class="content-text">
                {{ section.content }}
              </div>
            </v-col>
          </template>

          <template v-if="section.type == 'charts'">
            <template v-for="(chart, j) in section.charts">
              <v-col cols="1" :key="`chart${i}.${j}.1`"> </v-col>
              <v-col cols="4" :key="`chart${i}.${j}.2`">
                <template v-if="chart.chartType == 'horizontal-bar'">
                  <HorizontalBarChart
                    :variable="chart.variable"
                    :title="chart.title"
                    :perInhabitant="
                      'perInhabitant' in chart && chart.perInhabitant
                    "
                  />
                </template>
                <template v-if="chart.chartType == 'pie'">
                  <PieChart
                    :title="chart.title"
                    :data="chart.data"
                    :labels="chart.labels"
                    :colors="chart.colors"
                  />
                </template>
                <template v-if="chart.chartType == 'map'">
                  <div class="map-title">{{ chart.title }}</div>
                  <Map
                    :values="getValuesForMap(chart.variable)"
                    normalization="none"
                  />
                </template>
              </v-col>
            </template>
          </template>

          <template v-if="section.type == 'references'">
            <v-col cols="12">
              <div class="content-title" v-if="'title' in section">
                {{ section.title }}
              </div>
              <References :references="section.bronnen" />
            </v-col>
          </template>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="content-title">
              <a :href="justificationDocUrl" target="_blank"
                >Verantwoording indicatoren (PDF)</a
              >
            </div>
            <div class="spacing"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HorizontalBarChart from "@/components/HorizontalBarChart.vue";
import PieChart from "@/components/PieChart.vue";
import Map from "@/components/Map.vue";
import References from "@/components/References.vue";
import { json } from "d3-fetch";
export default {
  data: () => ({
    pageContent: null
  }),
  components: {
    HorizontalBarChart,
    PieChart,
    Map,
    References
  },
  mounted() {
    json(`${process.env.VUE_APP_DATA_DIR}data/analyses/${this.id}.json`).then(
      data => {
        this.pageContent = data;
      }
    );
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    type() {
      return this.$route.params.type;
    },
    imgUrl() {
      return this.pageContent && "image" in this.pageContent
        ? `${process.env.VUE_APP_DATA_DIR}${this.pageContent.image}`
        : "";
    },
    justificationDocUrl() {
      return `${process.env.VUE_APP_DATA_DIR}data/${process.env.VUE_APP_VERANTWOORDING_DOC}`;
    },
    dataDeelRegios() {
      return this.$store.getters.data_deelregios;
    }
  },
  methods: {
    getValuesForMap(variableName) {
      let values = {};
      for (const [key, valueList] of Object.entries(this.dataDeelRegios)) {
        const value = parseFloat(valueList[variableName]);
        values[key] = value;
      }
      return values;
    }
  }
};
</script>

<style lang="css" scoped>
.spacing {
  height: 50px;
}
.content-title {
  padding: 0px 25px;
  font-weight: bold;
}
.content-text {
  padding: 0px 25px;
  background-color: #ffffff;
}
.content-text.emphasis {
  font-weight: bold;
}
.page-title {
  font-size: 1.2em;
  font-weight: bold;
  margin: 60px 5px;
}
.side-bar {
  background-color: #ededed;
}
.nav {
  margin: 0px 20px;
}
.nav-link {
  margin: 10px 0px;
}
.map-title {
  font-size: 1.1em;
  font-weight: bold;
}
</style>
